import { InjectionToken } from '@angular/core';

export interface ClientEnvironment {
    authenticationUrl: string;
    portalApiUrl: string;
    coreUiUrl: string;
    sharedUiUrl: string;
}

export interface EndpointsConfig {
    identityServerEndpoint: string;
    webApiServerEndpoint: string;
    quantiumCoreHostname: string;
    quantiumSharedHostname: string;
    azureFunctionEndpoint: string;
}

export const ENDPOINTS_CONFIG = new InjectionToken<EndpointsConfig>('Environment\'s endpoints configuration');
